/* eslint-disable */
import NativeSelect from '../../utils/NativeSelect'
import VueForm from '../../../scripts/VueFormSetup'
var component = VueForm.Crud('users', {
    formMode: 'Add',
    valid: false,
    addForm: true,
    formDialog: false,
    searchTerm: '',
    loading: true,
    tableTitle: '',
    searchFormTitle: 'Cuentas de Usuario',
    //searchForm: {
    //    id: 'carriers',
    //    name: 'carriers',
    //    action: '/Carriers/Search',
    //    method: 'get',
    //    enctype: 'application/x-www-form-urlencoded'
    //},
    //searchFormInputs: [
    //    {
    //        inputType: 'textfield',
    //        model: '',
    //        'prepend-icon': 'search',
    //        counter: 45,
    //        maxlength: 45,
    //        label: 'Search',
    //        'v-on:keyup.enter': 'search',
    //        'data-vv-name': 'Search'
    //    }
    //],
    headers: [
        { text: 'Nombre Completo', value: 'Fullname' },
        { text: 'Nombre de Usuario', value: 'UserName' },
        { text: 'Correo Electronico', value: 'Email' },
        { text: 'Roles', value: 'Role' },
        { text: 'Acciones', value: 'Id' }
    ],
    rows: [],
    formTitle: 'Forma Cuentas de Usuario',
    form: {
        id: 'Account',
        name: 'Account',
        action: 'Account',
        method: 'post',
        enctype: 'multipart/form-data'
    },
    formInputs: [
        {
            inputType: 'hidden',
            id: 'Id',
            name: 'Id',
            model: ''
        },
        {
            inputType: 'nativeselect',
            id: 'Role',
            name: 'Role',
            model: 'Admin',
            'item-text': 'text',
            'item-value': 'value',
            items: [
                { value: 'Admin', text: 'Admin' },
                { value: 'Monitor', text: 'Monitor' },
                { value: 'Graduados', text: 'Graduados' },
                { value: 'Diploma', text: 'Diploma' },
                { value: 'Estadisticos', text: 'Estadisticos' }
            ],
            label: 'Rol',
            hint: "El rol determina los accesos a las diferentes aplicaciones. El admin tiene accesos a todas las aplicaciones.",
            'persistent-hint': true,
            'style': 'width:350px'
            // Don't use Placeholder, select a default value instead
            // placeholder: 'Select an Option',
            //required: true
        },
        {
            inputType: 'nativeselect',
            id: 'REGION_NAME',
            name: 'REGION_NAME',
            model: 'ARECIBO',
            'item-text': 'REGION_NAME',
            'item-value': 'REGION_NAME',
            items: [],
            label: 'Región',
            hint: "La región determina las escuelas a la que el estadístico estará asignado.",
            'persistent-hint': true,
            'style': 'width:350px'
            // Don't use Placeholder, select a default value instead
            // placeholder: 'Select an Option',
            //required: true
        },
        {
            id: 'Fullname',
            name: 'Fullname',
            model: '',
            counter: 256,
            maxlength: 256,
            rules: [
                v => !!v || /\s/.test(v) || 'El nombre completo es requerido'
            ],
            label: 'Nombre Completo',
        },
        {
            id: 'UserName',
            name: 'UserName',
            model: '',
            counter: 256,
            maxlength: 256,
            rules: [
                v => !!v || /\s/.test(v) || 'El nombre de usuario es requerido'
            ],
            label: 'Nombre de Usuario',
        },
        {
            id: 'Email',
            name: 'Email',
            model: '',
            counter: 256,
            maxlength: 256,
            rules: [
                v => !!v || 'El correo electrónico es requerido',
                v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'El correo electrónico es inválido'
            ],
            label: 'Correo Electrónico',
        },
        {
            id: 'Password',
            name: 'Password',
            type: 'password',
            model: '',
            counter: 50,
            maxlength: 50,
            rules: [
                v => !!v || 'La contraseña es requerido',
                v => /((?=.*\d)(?=.*[A-Z])(?=.*\W).{6,})/.test(v) || 'La contraseña debe contener al menos una letra mayúscula, una letra minúscula, un número, un carácter especial y un largo mínimo de 6 caracteres.'
            ],
            label: 'Contraseña',
        }//,
        //{
        //    id: 'ConfirmPassword',
        //    name: 'ConfirmPassword',
        //    type: 'password',
        //    model: '',
        //    counter: 50,
        //    maxlength: 50,
        //    rules: [
        //        v => !!v || 'La contraseña es requerido',
        //        v => /((?=.*\d)(?=.*[A-Z])(?=.*\W).{6,})/.test(v) || 'La contraseña debe contener al menos una letra mayúscula, una letra minúscula, un número, un carácter especial y un largo mínimo de 6 caracteres.'
        //    ],
        //    label: 'Confirmar Contraseña',
        //}
    ]
},
    'Id',
    '/account/get',
    '/account/del'
)
component.components = { NativeSelect }
component.mounted = function () {
    //this.peformFormSetup()
    this.loadAccounts()
    this.loadRegions()
}
component.methods.loadAccounts = function () {
    var self = this
    self.loading = true
    this.$ajax.get("/account/search",
        { txtSearch: '' })
        .then((response) => {
            self.rows = response.data
            self.loading = false
        })
        .catch((response) => {
            self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
            self.loading = false
        })
}
component.methods.loadRegions = function () {
    var self = this
    this.$ajax.get("/ENROLLMENT_TRANSACTION/GetAllRegionsList")
        .then((response) => {
            self.formInputs[2].items = response.data
            document.querySelector("#REGION_NAME").value = 'ARECIBO'
        })
        .catch((response) => {
            self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
        })
}
component.methods.reset = function() {
    this.$refs.form.reset()
    this.formInputs[3].model = ''
    this.formInputs[4].model = ''
    this.formInputs[6].model = ''
    this.formDialog = false
}
component.watch = {
    formInputs: {
        handler: function (after, before) {
            if (this.formInputs[1].model == "Graduados") {
                this.formInputs[2].model = "ARECIBO"
            }
        },
        deep: true
    }
}
component.methods.LockUnlockUserAccount = function (Id, LockoutEnabled, $event, props) {
    var self = this;
    //Blockeamos
    if (LockoutEnabled) {
        self.$ajax.post("/Account/UnlockUserAccount", {
            userId: Id
        }).then(function (params) {
            if (params.data === "OK") {
                self.$root.$snackbar('La cuenta ha sido desbloqueada existosamente.', { color: 'success' })
                props.item.LockoutEnabled = false;
            }
        }).catch((params) => {
            self.$root.$snackbar('Ha ocurrido un error mientras se trataba de desbloquear la cuenta.', {color: 'error'})
        })
    }
    //Desbloqueamos
    else {
        self.$ajax.post("/Account/LockUserAccount", {
            userId: Id
        }).then(function (params) {
            if (params.data === "OK") {
                self.$root.$snackbar('La cuenta ha sido bloqueada existosamente.', { color: 'success' })
                props.item.LockoutEnabled = true;
            }
        }).catch((params) => {
            self.$root.$snackbar('Ha ocurrido un error mientras se trataba de bloquear la cuenta.', { color: 'error' })
        })
    }
}
export default component


// WEBPACK FOOTER //
// ./src/components/account/index/script.js